import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import ErrorMessage from "../../components/ErrorMessage";
import {BrowserRouter as Router, Redirect} from "react-router-dom";
import {Form, Col, InputGroup, Button, ButtonGroup, Image} from "react-bootstrap";
import {config} from "../../components/Constants";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import BlankImage from "../../../assets/images/blank.gif";
import DefaultAvatar from "../../../assets/images/avatar.png";

class MessagesEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      submitError: null,
      isLoaded: true,
      isLoggedIn: false,
      isSubmitting: false,
      redirect: null,
      message: null,
      types: [],
      clients: [],
    };
    this.ckeditor = null;
    this.setImage = this.setImage.bind(this);
    this.MessageStatuses = null;
    this.handleSubmitForm = this.handleSubmitForm.bind(this);
    this.handleReturn = this.handleReturn.bind(this);
  }

  componentDidMount() {
    this.MessageStatuses = this.props.MessageStatuses;
    if(this.props.match.params.id) {
      fetch(config.API_URL + '/api/messages/edit/' + this.props.match.params.id, {
        credentials: 'include'
      })
        .then(res => res.json())
        .then(
          (result) => {
            if (result.error) {
              this.setState({
                message: null,
                isLoaded: true,
                error: result.error
              });
            } else if (result) {
              this.setState({
                message: result.message,
                clients: result.clients,
                types: result.types,
                isLoaded: true
              });
            }
          },
          (error) => {
            this.setState({
              message: null,
              isLoaded: true,
              error: error
            });
          }
        );
    } else {
      let message = {
        'od': '',
        'do': '',
        'tresc': '',
        'klienci_id': null,
        'klienci_komunikaty_typy_id': null,
      };
      fetch(config.API_URL + '/api/messages/properties', {
        credentials: 'include'
      })
        .then(res => res.json())
        .then(
          (result) => {
            if (result.error) {
              this.setState({
                message: message,
                isLoaded: true,
                error: result.error
              });
            } else if (result) {
              this.setState({
                message: message,
                clients: result.clients,
                types: result.types,
                isLoaded: true
              });
            }
          },
          (error) => {
            this.setState({
              message: message,
              isLoaded: true,
              error: error
            });
          }
        );
    }
  }

  handleSubmitForm(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    this.setState({
      isSubmitting: true
    });
    const formData = new FormData(event.target);
    let data = {};
    formData.forEach((val, mkey) => {
      data[mkey] = val;
    });
    data['tresc'] = this.ckeditor.getData()
    fetch(config.API_URL + '/api/messages/update',{
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      'method': 'POST',
      'body': JSON.stringify(data)
    })
      .then(res => res.json())
      .then(
        (result) => {
          if (result.error) {
            this.setState({
              isSubmitting: false,
              submitError: result.error
            });
          } else if (result) {
            this.setState({
              isSubmitting: false,
              redirect: '/messages'
            });
          }
        },
        (error) => {
          this.setState({
            isSubmitting: false,
            submitError: error
          });
        }
      );
    return false;
  }

  handleReturn(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    this.setState({
      redirect: '/messages'
    });
    return false;
  }

  setImage(event){
    const types = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const maxFileSize = 2;
    if(event){
      let fileInput = event.target;
      if(fileInput.files && fileInput.files.length > 0){
        if(fileInput.files.length > 1){
          this.setState({
            submitError: 'Można wstawić tylko jeden plik!'
          });
        } else {
          let file = fileInput.files[0];
          if(types.every(type => file.type !== type)){
            this.setState({
              submitError: 'Nieprawidłowy typ pliku, dozwolone są tylko obrazy JPG, PNG oraz GIF'
            });
          } else {
            if(file.size > (maxFileSize*1024*1024)){
              this.setState({
                submitError: 'Przesłany plik jest za duży! Maksymalna wielkość pliku to '+maxFileSize+'MB'
              });
            } else {
              let image = document.getElementById('messageImage');
              let field = document.getElementById('imageInputField');
              let fieldName = document.getElementById('imageFileName');
              var reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function (e) {
                console.log(file);
                image.style.backgroundImage = 'url('+e.target.result+')';
                field.value = e.target.result;
                fieldName.value = file.name;
              }
            }
          }
        }
      }
    }
  }
  render() {
    const {error, isLoaded, isLoggedIn, isSubmitting, submitError, redirect, message, clients, types} = this.state;
    const that = this;
    if (!isLoaded || message === null) {
      return (
        <LoadingSpin/>
      );
    } else if (redirect !== null) {
      return <Redirect to={redirect}/>
    } else if (error) {
      return (
        <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
          {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/messages', error: null});}}
        ]} handleClose={() => {that.setState({redirect: '/messages', error: null});}}/>
      );
    } else {
      let image = DefaultAvatar;
      if(message && message.image){
        image = message.image;
      }
      return (
        <React.Fragment>
          {isSubmitting ? <LoadingSpin/> : ''}
          <header className="clients-header">
            <h1>Edycja komunikatu {message.nazwa}</h1>
          </header>
          <div className="section-div">
            {submitError !== null ? <ErrorMessage title="Pojawiły się błędy" text={submitError} buttons={[
              {'title': 'OK', 'callback': function() {that.setState({submitError: null});}}
            ]} handleClose={() => {that.setState({submitError: null});}}/> : ''}
            <Form method="post" onSubmit={this.handleSubmitForm}>
              <Form.Control type="hidden" defaultValue={message.id} name="id"/>
              <Form.Control type="hidden" name="image" id="imageInputField"/>
              <Form.Control type="hidden" name="imageFileName" id="imageFileName"/>
              <h2>Dane podstawowe:</h2>
              <Form.Row>
                <Form.Group as={Col} md={6} sm={12} controlId="formGridTitle">
                  <Form.Label>
                    Tytuł:
                  </Form.Label>
                  <Form.Control defaultValue={message.tytul} name="tytul" type="text" placeholder="Wprowadź tytuł" required={true}/>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group  as={Col} sm={12} controlId="formGridLogin">
                  <Form.Label className="avatarUpload">
                    <Image src={BlankImage} style={{
                      backgroundImage: 'url('+image+')'
                    }} id="messageImage"></Image>
                    <Form.Control name="imageFile" type="file" onChange={this.setImage}/>
                  </Form.Label>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} sm={12} controlId="formGridTitle">
                  <Form.Label>
                    Treść komunikatu:
                  </Form.Label>
                  <CKEditor
                    editor={ ClassicEditor }
                    data={message.tresc}
                    name="tresc"
                    onReady={ editor => {
                      this.ckeditor = editor;
                    } }
                  />
                </Form.Group>
              </Form.Row>
              <h2>Ustawienia:</h2>
              <Form.Row>
                <Form.Group as={Col} md={6} sm={12} controlId="formGridClient">
                  <Form.Label>
                    Klient:
                  </Form.Label>
                  <Form.Control as="select" name="klienci_id" defaultValue={message.klienci_id}>
                    <option value="">-- Wszyscy --</option>
                    {clients.map((state, mkey) => {
                      return (
                        <option value={state.id} key={mkey}>{state.nazwa}</option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col} md={6} sm={12} controlId="formGridType">
                  <Form.Label>
                    Typ:
                  </Form.Label>
                  <Form.Control as="select" name="klienci_komunikaty_typy_id" type="text" defaultValue={message.klienci_komunikaty_typy_id}>
                    {types.map((type, mkey) => {
                      return (
                        <option value={type.id} key={mkey}>{type.nazwa}</option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} md={6} sm={12} controlId="formGridStatus">
                  <Form.Label>
                    Status:
                  </Form.Label>
                  <Form.Control as="select" name="status" type="text" required={true} defaultValue={message.status}>
                    {this.MessageStatuses.map((state, mkey) => {
                      return (
                        <option value={state.id} key={mkey}>{state.name}</option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
                <Form.Group as={Col} md={6} sm={12} controlId="formGridDateFrom">
                  <Form.Label>
                    Pokaż odmierzanie czasu:
                    Jeśli pozostawisz puste, timer się nie pokaże
                  </Form.Label>
                  <Form.Control defaultValue={message.timer_do} name="timer_do" type="datetime-local" placeholder="Wprowadź datę lub pozostaw puste"/>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} md={6} sm={12} controlId="formGridDateFrom">
                  <Form.Label>
                    Data od:
                  </Form.Label>
                  <Form.Control defaultValue={message.od} name="data_od" type="date" placeholder="Wprowadź datę lub pozostaw puste"/>
                </Form.Group>
                <Form.Group as={Col} md={6} sm={12} controlId="formGridDateTo">
                  <Form.Label>
                    Data do:
                  </Form.Label>
                  <Form.Control defaultValue={message.do} name="data_do" type="date" placeholder="Wprowadź datę lub pozostaw puste"/>
                </Form.Group>
              </Form.Row>
              <div className="downbuttons">
                <Button type="submit" name="submit">Zapisz</Button> <Button onClick={this.handleReturn}>Powrót</Button>
              </div>
            </Form>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default MessagesEdit;
